import React from 'react';
import { getFileExtensionLabel, splitFileNameParts } from '../../utils/fileUtils';

const FileNameWithExtension = ({
  fileName,
  className = '',
  nameClassName = '',
  tagClassName = '',
  title,
}) => {
  const { baseName, extension } = splitFileNameParts(fileName || '');
  const extTag = extension ? getFileExtensionLabel(fileName) : '';

  return (
    <span
      className={`inline-flex items-center gap-1.5 min-w-0 max-w-full ${className}`}
      title={title || fileName}
    >
      <span className={`truncate ${nameClassName}`}>
        {baseName || fileName}
        {extension && (
          <span className="text-gray-500 dark:text-gray-400 font-normal">{extension}</span>
        )}
      </span>
      {extTag && (
        <span
          className={`flex-shrink-0 px-1.5 py-0.5 rounded text-[9px] font-bold uppercase tracking-wide bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300 ${tagClassName}`}
        >
          {extTag}
        </span>
      )}
    </span>
  );
};

export default FileNameWithExtension;
